import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS } from 'src/constants/constants';
import { ILocation } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateLocationsConfig = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: updateLocationsConfig,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.locations.invalidateAll());
      queryClient.invalidateQueries(queryKeys.viewLocationsByGroups.all());
      queryClient.invalidateQueries(queryKeys.viewLocations.invalidateAll());
      queryClient.refetchQueries(queryKeys.locationListing.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.getLocationGroupsWithLocationCount.invalidateAll(),
      );
      onSuccessCallback?.();
    },
  });
};

const updateLocationsConfig = async (payload: ILocation[]) => {
  const data = {
    data: payload.map((location) => ({
      resource: COLLECTIONS.LOCATIONS,
      method: 'PATCH',
      id: location.location_code,
      data: {
        config: location.config,
        narrative: location.narrative,
      },
    })),
  };

  return requestCCApi({ url: '/transaction', method: 'POST', data });
};
